import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'avatar-icon',
  templateUrl: './avatar-icon.component.html',
  styleUrls: ['./avatar-icon.component.scss']
})
export class AvatarIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

  @Input() avatarSrc:string;
  @Input() initials:string;
  @Input() size='medium';

}
